import { PivotFilterOperatorEnum } from '@ztechapps/common.contract'

/** Whether a pivot filter operator names a relative date unit instead of an operand — `last`, `current` and `next`. */
export const isPivotRelativeOperator = (operator: PivotFilterOperatorEnum): boolean =>
  operator === PivotFilterOperatorEnum.last ||
  operator === PivotFilterOperatorEnum.current ||
  operator === PivotFilterOperatorEnum.next
